
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Types for our database - UPDATED TO MATCH CUSTOM SCHEMA
export interface Job {
  id: string;
  title: string;
  company: string;
  location: string;
  salary_range: string;
  job_type: string; // Changed from work_type
  experience_level: string; // Changed from experience
  description: string;
  requirements: string; // TEXT field, not array
  benefits: string; // TEXT field, not array
  tags: string[];
  company_logo: string; // Changed from logo
  created_at: string;
}

export interface Application {
  id: string;
  job_id: string;
  user_id: string;
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  resume_url: string;
  cover_letter: string;
  created_at: string;
}

export interface Profile {
  id: string;
  email: string;
  full_name: string;
  resume_url: string;
  created_at: string;
}
